// extracted by mini-css-extract-plugin
export default {"app":"Layout_app__Zie0e"};